import React from 'react';
import ReactDOM from 'react-dom';
// import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.js';
//import 'bootstrap/dist/css/bootstrap.css';
// import 'admin-lte';

import './assets/css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <App />
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
